import { queryOptions } from "@tanstack/react-query";
import { STALE } from "@/lib/api/query-client";
import { keys } from "@/lib/api/query-keys";
import { notificationsApi } from "./notifications.api";
import type { AnnouncementFilters, NotificationFilters } from "./notifications.types";

/**
 * The inbox is the liveliest list in the product — it changes while somebody looks at it — so
 * it takes the live staleness budget and keeps its previous page between fetches.
 */
export const notificationListQuery = (filters: NotificationFilters) =>
  queryOptions({
    queryKey: keys.notifications.list(filters),
    queryFn: () => notificationsApi.list(filters),
    staleTime: STALE.live,
  });

/** The header badge. Its own key so paging the inbox does not refetch it, and vice versa. */
export const unreadCountQuery = () =>
  queryOptions({
    queryKey: keys.notifications.unreadCount(),
    queryFn: () => notificationsApi.unreadCount(),
    staleTime: STALE.live,
  });

/**
 * What the caller should see right now. No filters: the server decides the window and the
 * audience, which is the whole point — a client that filtered by date would be re-deciding
 * "published" with a different clock.
 */
export const activeAnnouncementsQuery = () =>
  queryOptions({
    queryKey: keys.notifications.announcements({ scope: "active" }),
    queryFn: () => notificationsApi.activeAnnouncements(),
    staleTime: STALE.record,
  });

export const announcementListQuery = (filters: AnnouncementFilters) =>
  queryOptions({
    queryKey: keys.notifications.announcements(filters),
    queryFn: () => notificationsApi.announcements(filters),
    staleTime: STALE.record,
  });
